import { FC, useLayoutEffect, useRef, useState } from 'react';
import { FreeMode, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import Container from '~/components/Container';
import SectionTitle from '~/components/SectionTitle';
import { styles as TextStyles } from '~/components/Text';
import { replaceClassNames } from '~/utils/converters';
import styles from './TopCategory.module.scss';
import useClient from '~/hooks/useClient';
import React from 'react';
import classNames from 'classnames';
import parse from 'html-react-parser';

interface TopCategoryProps {
    data?: any;
}

const TopCategory: FC<TopCategoryProps> = ({ data }) => {
    const isClient = useClient();
    const [items, setItems] = useState<Element[]>([]);

    const [childrenExist, setChildrenExist] = useState(false);

    const _title = (data)?.title;
    const content = (data)?.content;
    const cmsBlock = replaceClassNames(content, {
        TopCategory: styles,
        Text: TextStyles
    });

    const transform = (node: any) => {
        // Check if the node is an element (not text)
        if (node?.props?.className?.includes("TopCategory") && node?.props?.children?.find((child: any) => child?.props?.className?.includes("TopCategory") !== undefined)) {
            return {
                ...node,
                props: {
                    ...node.props,
                    className: "mr-2.5 md:w-[calc((100vw-68px)/4.5)] sm:w-[calc((100vw-68px)/3.5)] lg:w-[calc((100vw-104px)/6.5)] xl:w-[calc((1296px-55px)/6.5)]"
                }
            };

        } else if (node?.props?.className?.includes("TopCategory")) {
            return {
                ...node,
                props: {
                    ...node.props,
                    className: "w-inherit"
                }
            };
        } else return node;
    };

    const cmsBlockRef = useRef<HTMLDivElement>(null);
    useLayoutEffect(() => {
        if (cmsBlockRef.current) {
            cmsBlockRef.current.innerHTML = cmsBlock;
        }
        const items = Array.from(document.getElementsByClassName(styles.category_item));
        setItems(items);
        setChildrenExist(items.length > 0);
    }, [cmsBlock]);

    if (!content) {
        return null;
    }

    return (
        <React.Fragment>
            <Container rootClassName={styles.top_category_wrapper}>
                {_title ? <SectionTitle centered text={_title} /> : null}
                {!!isClient && childrenExist && (
                    <Swiper
                        slidesPerView={3.5}
                        spaceBetween={10}
                        autoplay={{ delay: 3000 }}
                        freeMode
                        loop={items.length > 6}
                        modules={[FreeMode, Navigation, Pagination]}
                        navigation={{
                            enabled: false
                        }}
                        observer={true}
                        breakpoints={{
                            480: {
                                slidesPerView: 3.5
                            },
                            768: {
                                slidesPerView: 4.5
                            },
                            1024: {
                                slidesPerView: 6.5,
                                navigation: {
                                    enabled: true
                                }
                            }
                        }}
                    >
                        {items.map((child, index) => (
                            <SwiperSlide key={index}>
                                <div dangerouslySetInnerHTML={{ __html: child.outerHTML }} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}
                <div
                    ref={cmsBlockRef}
                    className="hidden"
                    dangerouslySetInnerHTML={{
                        __html: cmsBlock
                    }}
                />
                <div
                    className={classNames({
                        "hidden": isClient,
                        "flex overflow-hidden relative": !isClient,
                        [styles.category_wrap]: !isClient,
                    })}
                >
                    {(content && parse(content, { transform }) as any)?.filter((item: any) => item !== "\r\n")}
                </div>
            </Container>
        </React.Fragment >
    );
};

export default TopCategory;
